import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import Button from 'srcReact/components/common2/Button'
import Icon from 'srcReact/components/icons/Icon'
import { TextBox } from 'srcReact/components/common2/TextBox'

// import { profileActions as pa } from '../../../../action'
import SocialLinks from '../../../SocialLinks'
import styles from './styles.module.scss'
import Avatar from 'srcReact/components/common2/Avatar'

export default function ProfileCard() {
  const { t } = useTranslation()
  const [decryptedImage, setDecryptedImage] = useState('')
  // const dispatch = useDispatch()

  const {
    myProfile: { profileData, userStatus },
    login: { user: loggedInUser }
  } = useSelector((state) => state)

  const [number, setNumber] = useState('')
  const [email, setEmail] = useState('')
  const [pronoun, setPronoun] = useState('')
  // const [shortDesc, setShortDesc] = useState('')
  // const [shortDescBtn, setShortDescBtn] = useState(false)

  useEffect(() => {
    setNumber({ ...number, value: profileData.user.phone_number })
    setEmail({ ...email, value: profileData.user.email })
    assignPronoun()
    // setShortDesc(profileData.user.small_bio)
  }, [profileData])

  const assignPronoun = () => {
    if (profileData.user.preferred_pronoun === 'he') {
      setPronoun(t('my_profile.pronoun.he_him'))
    } else if (profileData.user.preferred_pronoun === 'she') {
      setPronoun(t('my_profile.pronoun.she_her'))
    } else if (profileData.user.preferred_pronoun === 'they') {
      setPronoun(t('my_profile.pronoun.they_them'))
    } else if (profileData.user.preferred_pronoun === null) {
      setPronoun('')
    }
  }

  return (
    <div className={`${styles.profileCard}`}>
      <Avatar
        userId={profileData.user?.id}
        firstname={profileData.user?.first_name}
        lastname={profileData.user?.last_name}
        profilePicture={profileData.user?.profile_picture_data?.profile_picture}
        rounded
        mimeType={profileData.user?.profile_picture_data?.mime_type}
        originalTag={profileData.user?.profile_picture_data?.original_tag}
        isOriginal={profileData.user?.profile_picture_data?.is_original}
        imgWrapperSize='large84'
      />
      {profileData.user.first_name && (
        <h2 className={`${styles.userName}`}>{`${profileData.user.first_name}${' '}${profileData.user.last_name}`}</h2>
      )}
      {profileData.user.is_display_pronoun === '1' && <h2 className={`${styles.pronoun}`}>{pronoun}</h2>}
      {profileData.user.current_occupation && (
        <h2 className={`${styles.pronoun}`}>
          {profileData.user.current_occupation.charAt(0).toUpperCase() + profileData.user.current_occupation.slice(1)}
        </h2>
      )}
      <SocialLinks
        messenger={profileData.editable === 1 ? false : true}
        linkedin={profileData.user.linkedIn_url ? true : false}
        instagram={profileData.user.instagram_url ? true : false}
      />
      {/* feature removed temporarily */}
      {/* <div className={`${styles.shortDescWrapper}`}>
        {profileData.editable === 1 ? (
          <textarea
            name='message'
            value={shortDesc}
            className={`${styles.shortDesc}`}
            rows='3'
            onChange={handleShortDesc}
            placeholder={t('my_profile.profile_card.small_bio')}
            aria-label={t('my_profile.profile_card.small_bio')}
          />
        ) : (
          <textarea
            name='message'
            value={shortDesc}
            className={`${styles.shortDesc}`}
            rows='3'
            onChange={handleShortDesc}
            placeholder={t('my_profile.profile_card.small_bio')}
            aria-label={t('my_profile.profile_card.small_bio')}
            readOnly
          />
        )}
      </div> */}
      {/* {shortDescBtn ? (
        <div className={`${styles.buttonWrap}`}>
          <Button
            text={t('my_profile.info_block.update')}
            handleClick={() => handleSubmit('small_bio', shortDesc)}
            size='medium'
          />
        </div>
      ) : (
        ''
      )} */}
      {profileData.user.is_display_phone === '1' || profileData.user.is_display_email === '1' ? (
        <div className={`${styles.contactWrap}`}>
          <h2 className={`${styles.contact}`}>{t('my_profile.profile_card.contact')}</h2>
          {profileData.user.is_display_phone === '1' && number.value !== '' && (
            <div className={`${styles.outerWrap}`}>
              <div className={`${styles.iconOuterWrap}`}>
                <div className={`${styles.iconWrap}`}>
                  <Icon name='phone' styleModifier={styles.icon} />
                </div>
                <TextBox
                  customWrapperCss={styles.inputWrap}
                  customInputCss={styles.input}
                  fieldInfo={number}
                  disabled
                />
              </div>
            </div>
          )}
          {profileData.user.is_display_email === '1' && email.value !== '' && (
            <div className={`${styles.outerWrap}`}>
              <div className={`${styles.iconOuterWrap}`}>
                <div className={`${styles.iconWrap}`}>
                  <Icon name='mail' styleModifier={styles.icon} />
                </div>
                <TextBox customWrapperCss={styles.inputWrap} customInputCss={styles.input} fieldInfo={email} disabled />
              </div>
            </div>
          )}
        </div>
      ) : (
        ''
      )}
      {profileData.editable === 1 || userStatus === 'deactivated' || userStatus === 'deleted' ? (
        ''
      ) : (
        <Link to={`/0/messenger/?userid=${profileData.user.id}/`}>
          <Button size='medium' customStyle={`${styles.profileBtn}`} text={t('my_profile.profile_card.message')} />
        </Link>
      )}
    </div>
  )
}
